import { createRootRouteWithContext } from '@tanstack/react-router'
import { Scope } from 'effector'

type RouterContext = { scope: Scope }

const createRoot = createRootRouteWithContext<RouterContext>()
export const rootRoute = createRoot()
